import { useSelector } from "react-redux";
import { selectCurrentToken } from "../features/auth/authSlice";
import jwtDecode from "jwt-decode";

const useAuth = () => {
  const token = useSelector(selectCurrentToken);
  let isExplorer = false;
  let isCreator = false;
  let status = "Viewer";

  // console.log(token);
  

  if (token) {
    const decoded = jwtDecode(token);
    // console.log(decoded.UserInfo);
    
    const { username, roles } = decoded.UserInfo;

    isExplorer = roles.includes("Explorer");
    isCreator = roles.includes("Creator");

    if (isExplorer) status = "Explorer";
    if (isCreator) status = "Creator";

    return { username, roles, status, isExplorer, isCreator };
  }

  return { username: "", roles: [], isExplorer, isCreator, status };
};
export default useAuth;
